export class Status {
  static NotStarted = 0;
  static InProgress = 10;
  static Completed = 100;
}
